export default "__VITE_ASSET__D3hI9im2__"